/**
 * Footer component.
 * @module components/theme/Footer/Footer
 *
 * Customization of `@plone/volto/src/components/theme/Footer/Footer`:
 * - custom branded markup (`footer-kg`) without the Plone attribution links;
 * - keeps the `siteActions` rendering from the Volto core footer.
 */
import './Footer.scss';
import React from 'react';
import map from 'lodash/map';
import { FormattedMessage } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers/Url/Url';

const Footer = () => {
  const { siteActions = [] } = useSelector(
    (state) => ({
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );

  return (
    <footer
      role="contentinfo"
      id="footer"
      aria-label="Footer"
      tabIndex="-1"
      className="footer-kg"
    >
      <section className="container">
        <ul className="siteActions">
          {siteActions?.length
            ? map(siteActions, (item) => (
                <li className="item" key={item.id}>
                  <UniversalLink
                    className="item"
                    href={
                      item.url ? flattenToAppURL(item.url) : addAppURL(item.id)
                    }
                  >
                    {item?.title}
                  </UniversalLink>
                </li>
              ))
            : null}
        </ul>
      </section>
      <section>
        <div className="small">
          <FormattedMessage
            id="Copyright Apanymantel"
            defaultMessage="Servicios KG online S.L. {copyright} is a registered brand 2011-{current_year}"
            values={{
              copyright: <abbr>©</abbr>,
              current_year: new Date().getFullYear(),
            }}
          />{' '}
        </div>
      </section>
    </footer>
  );
};

export default Footer;
